import React from 'react';
import { useReveal } from '../lib/useReveal';
const COST_DATA = [{
  without: 'Años sintiendo el llamado sin formación completa',
  cost: 'Tiempo que no vuelve'
}, {
  without: 'Cursos sueltos que no conectan',
  cost: 'Dinero gastado sin estructura real'
}, {
  without: 'Sin certificado oficial',
  cost: 'Clientes que dudan — precios que bajan'
}, {
  without: 'Sin protocolo de sintonizaciones',
  cost: 'Inseguridad en el momento más importante'
}, {
  without: 'Sin sistema de profesionalización',
  cost: 'Ingresos que no llegan'
}, {
  without: 'El mismo ciclo de postergación',
  cost: 'El próximo año — igual que este'
}];
export function CostComparisonSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-171">
      <div className="container mx-auto max-w-3xl" data-id="element-172">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-173">
          <div className="text-center mb-10" data-id="element-174">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-175">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-[#111111] rounded-2xl border border-white/10 overflow-hidden shadow-xl" data-id="element-176">
            <div className="grid grid-cols-2 bg-black/50 border-b border-white/10" data-id="element-177">
              <div className="p-4 md:p-5 text-center" data-id="element-178">
                <span className="text-gray-400 font-bold text-sm uppercase tracking-wider" data-id="element-179">
                  Sin MegaPack
                </span>
              </div>
              <div className="p-4 md:p-5 text-center border-l border-white/10" data-id="element-180">
                <span className="text-red-400 font-bold text-sm uppercase tracking-wider" data-id="element-181">
                  Costo real
                </span>
              </div>
            </div>

            <div className="divide-y divide-white/5" data-id="element-182">
              {COST_DATA.map((row, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-white/[0.02] transition-colors" data-id="element-183">
                  <div className="p-4 md:p-5 flex items-center justify-center text-center" data-id="element-184">
                    <span className="text-gray-300 text-sm" data-id="element-185">{row.without}</span>
                  </div>
                  <div className="p-4 md:p-5 border-l border-white/5 flex items-center justify-center text-center bg-red-950/10" data-id="element-186">
                    <span className="text-red-300/80 font-medium text-sm" data-id="element-187">
                      {row.cost}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}